import { render, staticRenderFns } from "./bullMonthlySemenStock.vue?vue&type=template&id=06562601&scoped=true&"
import script from "./bullMonthlySemenStock.vue?vue&type=script&lang=js&"
export * from "./bullMonthlySemenStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06562601",
  null
  
)

export default component.exports